export const Theme = {
  breakpoints: ["48em", "64em", "85.375em", "120em", "160em"],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: `Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    heading: "inherit",
    monospace: "Menlo, monospace",
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 600,
    medium: 500,
  },
  lineHeights: {
    body: 1.55,
    heading: 1.3,
  },
  radii: {
    sm: 6,
    md: 10,
    lg: 14,
    pill: 9999,
  },
  colors: {
    text: "#0a2540",
    textSecondary: "#425466",
    textMuted: "#6c7684",
    background: "#ffffff",
    surface: "#f6f9fc",
    border: "#e6ebf1",
    borderStrong: "#cbd5e1",
    primary: "#111111",
    primaryHover: "#333333",
    primaryMuted: "rgba(17, 17, 17, 0.08)",
    overlayBackdrop: "rgba(15, 23, 42, 0.48)",
    secondary: "#6c7684",
    muted: "#f6f9fc",
  },
  shadows: {
    small: "0 1px 2px rgba(15, 23, 42, 0.06)",
    card: "0px 1px 2px rgba(15, 23, 42, 0.04), 0px 12px 40px rgba(15, 23, 42, 0.12)",
    large: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    focusRing: "0 0 0 3px rgba(17, 17, 17, 0.2)",
  },
  variants: {},
  text: {
    heading: {
      fontFamily: "heading",
      color: "rgba(255, 255, 255, .95)",
    },
    white: {
      color: "rgba(255, 255, 255, .87)",
    },
    title: {
      color: "text",
      fontWeight: "heading",
      letterSpacing: "-0.02em",
    },
    body: {
      color: "textSecondary",
      fontWeight: "body",
    },
  },
  buttons: {
    ghost: {
      bg: "transparent",
      color: "textMuted",
      border: "1px solid transparent",
      borderRadius: "8px",
      boxShadow: "none",
      fontFamily: "inherit",
      fontWeight: "body",
      outline: "none",
      cursor: "pointer",
      transition: "background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease",
      ":hover": {
        bg: "surface",
        color: "text",
        borderColor: "border",
        boxShadow: "none",
      },
      ":focus": {
        boxShadow: "none",
      },
      ":active": {
        boxShadow: "none",
        transform: "none",
      },
      ":focus-visible": {
        boxShadow: "0 0 0 2px rgba(17, 17, 17, 0.12)",
        borderColor: "borderStrong",
      },
    },
    primary: {
      color: "background",
      bg: "primary",
      fontFamily: "inherit",
      fontWeight: "medium",
      fontSize: 2,
      lineHeight: 1.4,
      border: "none",
      borderRadius: "10px",
      outline: "none",
      cursor: "pointer",
      py: "14px",
      px: "18px",
      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
      transition: "background-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease",
      ":hover": {
        bg: "primaryHover",
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.18)",
      },
      ":active": {
        transform: "translateY(1px)",
      },
    },
  },
  input: {
    py: "12px",
    px: "14px",
    border: "1px solid",
    borderColor: "border",
    borderRadius: "10px",
    color: "text",
    bg: "background",
    outline: "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    ":focus": {
      borderColor: "primary",
      boxShadow: "0 0 0 3px rgba(17, 17, 17, 0.2)",
    },
    "::placeholder": {
      color: "textMuted",
    },
  },
  select: {
    py: "12px",
    px: "14px",
    border: "1px solid",
    borderColor: "border",
    borderRadius: "10px",
  },
  styles: {
    root: {
      fontFamily: "body",
      fontWeight: "body",
      color: "text",
      WebkitFontSmoothing: "antialiased",
    },
    a: {
      color: "primary",
      textDecoration: "none",
      fontWeight: "medium",
      ":hover": {
        color: "primaryHover",
        textDecoration: "underline",
      },
      cursor: "pointer",
    },
  },
};
